import React, { Fragment, useCallback, useEffect } from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import AuthLayout from "../Layout/AuthLayout";
import { useGetBookmarkMutation } from "../Store/api/DataApi";
import JobItemComponent from "../Components/Bookmarked/JobItemComponent";
import { useNavigate } from "react-router-dom";
//import { logout } from "../Services/AuthService";

export default function Bookmarked() {
  let perPage = 10;
  //const [currentPage, setCurrentPage] = useState(1);
  const [getBookmark, { data }] = useGetBookmarkMutation();
  const navigate = useNavigate();

  const bookmarkList = useCallback(
    (page, size = perPage) => {
      let params = {
        page: page,
        limit: size,
      };
      getBookmark(params);
    },
    [perPage, getBookmark]
  );

  useEffect(() => {
    if (data?.error !== undefined && data?.error === "Invalid token!") {
      navigate("/logout");
    }
  }, [data, navigate]);

  useEffect(() => {
    bookmarkList(1);
  }, [bookmarkList]);

  return (
    <Fragment>
      <PageBannerComponent title="My Bookmarked Jobs" />
      <AuthLayout>
        {data?.data?.length > 0 ? (
          (data?.data).map((job, i) => <JobItemComponent item={job} key={i} />)
        ) : (
          <div className="inner-box my-resume">
            <div className="text-center h4">You have no bookmark job.</div>
          </div>
        )}
      </AuthLayout>
    </Fragment>
  );
}
